// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import taskTimeEntryEntity from './entities/task-time-entry.json';
import taskTimeEntryMenu from '../pages/task-time-entry/menu.json';
import taskTimeEntryFullForm from '../pages/task-time-entry/forms/full.json';
import taskTimeEntryContextForm from '../pages/task-time-entry/forms/context.json';
import taskTimeEntryMiniForm from '../pages/task-time-entry/forms/mini.json';
import taskTimeEntryLookupForm from '../pages/task-time-entry/forms/lookup.json';
import taskTimeEntryTableView from '../pages/task-time-entry/views/table.json';
import taskTimeEntryCardsView from '../pages/task-time-entry/views/cards.json';
import taskTimeEntryCalendarView from '../pages/task-time-entry/views/calendar.json';
import taskTimeEntryDashboardView from '../pages/task-time-entry/views/dashboard.json';

/** Тип запису «Запис часу» зі сторінками пакета: меню, форми та подання з pages/task-time-entry/. */
export const taskTimeEntryDefinition: IRecordTypeDefinition = {
  ...taskTimeEntryEntity,
  views: assembleViewSet({
      table: taskTimeEntryTableView,
      cards: taskTimeEntryCardsView,
      calendar: taskTimeEntryCalendarView,
      dashboard: taskTimeEntryDashboardView,
  }),
  form: taskTimeEntryFullForm,
  forms: { full: taskTimeEntryFullForm, context: taskTimeEntryContextForm, mini: taskTimeEntryMiniForm, lookup: taskTimeEntryLookupForm },
  menu: taskTimeEntryMenu,
} as IRecordTypeDefinition;
